import { render, staticRenderFns } from "./DkUSPOverlay.vue?vue&type=template&id=3870bfd9&"
import script from "./DkUSPOverlay.vue?vue&type=script&lang=js&"
export * from "./DkUSPOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports